import React from 'react';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <h1 className="hero-title">Golden Cars</h1>
        <p className="hero-subtitle">Peritaje & Respaldo Jurídico S.A.S.</p>
        <h2 className="hero-slogan">"Más que un peritaje, tu respaldo al comprar"</h2>
        <div className="hero-buttons">
          <a href="/asesoria" className="btn-hero-primary">Solicitar Asesoría</a>
          <a href="/calculadora-riesgos" className="btn-hero-secondary">Calculadora de Riesgos</a>
          <a href="/blog" className="btn-hero-secondary">Blog Legal</a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;